export default __webpack_public_path__ + "a82164bef7b3b68dd236d628f10f0732.svg";